import { render } from "./Page2.vue?vue&type=template&id=b04260ac&scoped=true"
import script from "./Page2.vue?vue&type=script&lang=js"
export * from "./Page2.vue?vue&type=script&lang=js"

import "./Page2.vue?vue&type=style&index=0&id=b04260ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b04260ac"]])

export default __exports__